
import { Component, Vue } from 'vue-property-decorator'
import { Field } from '@/services/utils/baseForm'
import { popUpRoute } from '@/services/utils/popupRoute'
import { parsePathQueryString } from '@/shared/helpers/parsePathQueryString'
import BaseForm from '@/stories/base-form/BaseForm.vue'
import { Route } from 'vue-router'
import eventBus from '@/eventBus'
import { freezeObject } from '@/shared/helpers/freezeObject'
import { localDeliveryEndpoints } from '@/modules/preference/local-delivery'
import { ILocalDelivery } from '@/modules/preference/local-delivery/types/localDeliveryTypes'
import { cityEndpoints } from '@/modules/preference/city'

@Component({
  name: 'TheUpsertWeightEstimationKeyword',
  components: {
    DialogBaseSkeleton: () =>
      import(
        /* webpackChunkName: "DialogBaseSkeleton" */ '@/stories/dialog-base-skeleton/DialogBaseSkeleton.vue'
      ),
    BaseForm
  }
})
export default class TheUpsertWeightEstimationKeyword extends Vue {
  loading = false
  id = parsePathQueryString(location.search).id || ''
  data = {} as ILocalDelivery
  originalData = {} as ILocalDelivery

  title = (_params: Route['params'], query: Route['query']) =>
    query.id
      ? `${this.$t('dialog.localDelivery.edit')}`
      : `${this.$t('dialog.localDelivery.addNew')}`

  /** function will be passed to child components */
  fields(): Field<ILocalDelivery>[] {
    return [
      Field.dropdown<ILocalDelivery>('city', 'cityId', () =>
        cityEndpoints.list()
      )
        .setCol('col-12')
        .required()
        .setProps({
          disabled: !!this?.id
        }),
      Field.currency<ILocalDelivery>('deliveryPrice', 'price')
        .setCol('col-12')
        .required()
        .setRules('min_value:0'),
      Field.currency<ILocalDelivery>('deliveryCost', 'cost')
        .setCol('col-12')
        .required()
        .setRules('min_value:0'),

      Field.checkbox<ILocalDelivery>('Default', 'isDefault')
        .setProps({
          color: 'primary'
        })
        .setCol('col-12')
    ]
  }

  /** submit the data to the desired endpoint. */
  async handleSubmit(
    values: ILocalDelivery,
    _p: Record<string, number>,
    q: Record<string, number>
  ) {
    if (q.id) {
      await localDeliveryEndpoints
        .patch(q.id, this.originalData, values)
        .then(() => popUpRoute.removeModalPath(['id']))
    } else
      await localDeliveryEndpoints.post(values).then(() => {
        popUpRoute.removeModalPath(['id'])
      })
    eventBus.refreshData()
  }

  bindSubmitTitle(_params: Route['params'], query: Route['query']): string {
    return query.id ? 'update' : 'add'
  }

  /** closePopUp function pass to the baseModal component */
  closePopUp() {
    popUpRoute.removeModalPath(['id'])
  }

  created() {
    this.fetchRemoteData()
  }

  /** call given fetch data function */
  async fetchRemoteData() {
    this.loading = true
    try {
      if (this.id) {
        this.data = await localDeliveryEndpoints.get(this.id)
        this.originalData = freezeObject(this.data)
      }
    } catch (error) {
      throw new Error(`Failed to fetch form data. Due to ${error}`)
    } finally {
      this.loading = false
    }
  }
}
